<template>
    <section class="img-responsive d-flex align-items-center justify-content-center flex-column">
        <div class="mb-50">
          <img-loader
            :src="gif"
            :alt="selectedTabGif"
            classImg="gif-image"
            :refId="selectedTabGif"
          />
        </div>
        <b-button-group class="mb-1">
            <b-button
                @click="setSelectedTabGif(CONDITIONS.TRACKING)"
                :variant="selectedTabGif === CONDITIONS.TRACKING ? 'primary' : 'outline-primary'"
                class="custom-button-gif-ws custom-button-gif-ws-left"
            >
                Tracking
            </b-button>
            <b-button
                @click="setSelectedTabGif(CONDITIONS.TICKET)"
                :variant="selectedTabGif === CONDITIONS.TICKET ? 'primary' : 'outline-primary'"
                class="custom-button-gif-ws custom-button-gif-ws-right"
            >
                Ticket
            </b-button>
        </b-button-group>
        <p class="text-center">Visualiza un giff de prueba con ejemplos de los distintos estados</p>
    </section>
</template>
<script>
export default {
  data() {
    return {
      selectedTabGif: 'tracking',
      typeGif: {
        tracking: 'https://firebasestorage.googleapis.com/v0/b/madagascar-stage.appspot.com/o/complementaryProducts%2Ftracking.png?alt=media&token=d4303d25-a23a-4fd7-8747-f77777113e7f',
        ticket: 'https://firebasestorage.googleapis.com/v0/b/madagascar-stage.appspot.com/o/complementaryProducts%2Fticket.png?alt=media&token=6eb2424e-3505-4e86-a27f-164ab156a24f'
      },
      CONDITIONS: Object.freeze({
        TRACKING: 'tracking',
        TICKET: 'ticket'
      })
    }
  },
  computed: {
    gif () {
      return this.typeGif[this.selectedTabGif]
    }
  },
  methods: {
    setSelectedTabGif (value) {
      this.selectedTabGif = value
    }
  }
}
</script>